import React from "react"
import { FileText, ExternalLink } from "lucide-react"
import { FeatureItem } from "../types/objects"
import { SectionHeading } from "./ui/SectionHeading"

/**
 * Props interface for Features component
 */
interface FeaturesProps {
	data?: FeatureItem[]
}

/**
 * Features Component — four pillars of what we do, plus the architecture showcase.
 */
export const Features: React.FC<FeaturesProps> = ({ data }) => {
	return (
		<section id="features" className="lp-section lp-section--soft lp-section--dots">
			<div className="lp-container">
				<SectionHeading
					eyebrow="Co děláme"
					title="Charakteristika"
					lead="Čtyři oblasti, ve kterých firmám pomáháme od prvního návrhu až po stabilní provoz."
				/>

				<div className="lp-grid lp-grid--4">
					{data ? (
						data.map((item, index) => (
							<article
								key={`${item.title}-${index}`}
								className="lp-card lp-card--bar lp-feature"
								data-reveal=""
								style={{ "--reveal-delay": `${index * 90}ms` } as React.CSSProperties}
							>
								<span className="lp-feature__index" aria-hidden="true">0{index + 1}</span>
								<span className="lp-icon-badge" aria-hidden="true">
									<i className={item.icon} />
								</span>
								<h3 className="lp-card__title">{item.title}</h3>
								<p className="lp-card__text">{item.text}</p>
							</article>
						))
					) : (
						<p>Načítám data...</p>
					)}
				</div>

				{/* Architecture showcase image in a browser-style frame */}
				<div className="lp-frame" data-reveal="scale">
					<div className="lp-frame__bar" aria-hidden="true">
						<span className="lp-frame__dot" />
						<span className="lp-frame__dot" />
						<span className="lp-frame__dot" />
						<span className="lp-frame__url">b2btechinsight.cz / optimalizace-it-platformy</span>
					</div>
					<a
						href="/img/IT-Platform-Optimization.jpeg"
						target="_blank"
						rel="noopener noreferrer"
						title="Otevřít obrázek v plné velikosti"
					>
						<img
							src="/img/IT-Platform-Optimization.jpeg"
							alt="IT Platform Optimization"
							loading="lazy"
						/>
					</a>
				</div>

				<div className="lp-actions-center" data-reveal="">
					<a
						href="/docs/b2b_integrace_zaklady.pdf"
						target="_blank"
						rel="noopener noreferrer"
						className="lp-btn lp-btn--primary"
					>
						<FileText size={18} /> Otevřít dokument architektury (PDF)
					</a>
					<a
						href="/img/IT-Platform-Optimization.jpeg"
						target="_blank"
						rel="noopener noreferrer"
						className="lp-btn lp-btn--outline"
					>
						Zobrazit schéma <ExternalLink size={16} />
					</a>
				</div>
			</div>
		</section>
	)
}
